import {MODEL_FILTER_SUCCESS, MODEL_FILTER_CLEAR, MODEL_NEWTICKET_SUCCESS, MODEL_NEWTICKET_CLEAR} from "../constants";


export function model_list_filter(state=[], action) {
    switch(action.type){
        case MODEL_FILTER_SUCCESS:
            return action.payload;
        case MODEL_FILTER_CLEAR:
            return state =[];
        default:
            return state;
    }
}
export function model_list_newticket(state=[], action) {
    switch(action.type){
        case MODEL_NEWTICKET_SUCCESS:
            return action.payload;
        case MODEL_NEWTICKET_CLEAR:
            return state =[];
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/modelTechnics.js